import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/client/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/vercel/path0/apps/client/src/lib/posthog/PostHogProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApolloWrapper"] */ "/vercel/path0/apps/client/src/utils/apollo/apollo-wrapper.tsx");
